import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import querystring from 'RootShared/utility/querystring';

const useQueryParamsFilter = (initialState, { initCallbacks, filter } = {}) => {
  const history = useHistory();
  const { location } = history;
  const [data, setData] = useState(initialState);
  const [isChanged, setIsChanged] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);

  const checkIsBoolean = (value) => (value === 'true' ? true : value === 'false' ? false : value);

  const getInitialQuery = (query) => {
    return Object.keys(data).reduce(
      (obj, key) => {
        if (key in query) {
          const valueNumber = +query[key];

          obj[key] = isNaN(valueNumber) ? checkIsBoolean(query[key]) : valueNumber;
        }

        return obj;
      },
      { ...data }
    );
  };

  useEffect(() => {
    const query = querystring.parse(location.search);
    const initialQuery = getInitialQuery(query);

    if (initCallbacks) {
      Object.keys(initCallbacks).forEach((key) => {
        if (key in initialQuery) initCallbacks[key](initialQuery[key]);
      });
    }

    setData(() => {
      setIsInitialized(true);

      return initialQuery;
    });
  }, []);

  const validateData = (data) => {
    return Object.keys(data).reduce((obj, key) => {
      let value = data[key];

      if (typeof value === 'boolean') value = value ? 'true' : 'false';
      if (value || value === 0) obj[key] = data[key];

      return obj;
    }, {});
  };

  const getNewQueryString = (existingQuery) => {
    const newQuery = validateData({ ...existingQuery, ...data });

    return querystring.stringify(filter ? filter(newQuery) : newQuery);
  };

  useEffect(() => {
    const { search, pathname } = location;
    const existingQuery = querystring.parse(search);

    history.push({
      pathname,
      search: getNewQueryString(existingQuery),
    });
  }, [data]);

  const setDataDecorator = (newState) => {
    setData(prevData => {
      const newData = typeof newState === 'function' ? newState(prevData) : newState;

      if (JSON.stringify(newData) !== JSON.stringify(prevData)) {
        if (!isChanged) setIsChanged(true);

        return newData;
      }

      return prevData;
    });
  };

  return [data, setDataDecorator, {isInitialized, isChanged}];
};

export default useQueryParamsFilter;
